<div class="tracker-page">
  <h2>Trackings</h2>
  <app-button-toggler [buttons]="buttons" [default]="buttons[0].value"
    (setSelected)="selectTimeEntry($event)"></app-button-toggler>

    @if (trackingEntryInCourse) {
      <app-time-entry-player [projects]="projects" [tags]="tags" [isRunning]="trackingEntryInCourse.isOngoing()" [trackEntry]="trackingEntryInCourse"
        (enterPressed)="onEnterPressed($event)"></app-time-entry-player>
    } @else {
      @if (timeEntrySelected === 'manual') {
        <app-time-entry-input [projects]="projects" [tags]="tags"
          (enterPressed)="onEnterPressed($event)"></app-time-entry-input>
      } @else {
        <app-time-entry-player [projects]="projects" [tags]="tags" [isRunning]="false"
          (enterPressed)="onEnterPressed($event)"></app-time-entry-player>
      }
    }


  <button mat-flat-button (click)="openItemAnnihilatorDialog('0ms', '0ms')">Delete trackings</button>

  <app-track-list [trackEntries]="trackEntries" [projects]="projects" [tags]="tags"
    (updateEntries)="onUpdateEntries($event)"></app-track-list>
</div>
